let buttonJSON = [];
let isInit = false;
export default function(code) {
	if (!isInit) {
		let globalButtonJSON = Vue.prototype.store.state.buttonJSON;
		if (globalButtonJSON !== undefined) {
			buttonJSON = globalButtonJSON;
			isInit = true;
		}
	}
	if (code != undefined) {
		let number = buttonJSON.indexOf(code);
		if (number === -1) {
			return true;
		} else {
			return false;
		}
	} else {
		console.error("buttonAuthority入参错误");
	}
}
